import { doc, setDoc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../utils/firebase";

export const createProfile = async (uid, profileData) => {
  try {
    const profileRef = doc(db, "user_profiles", uid);
    
    await setDoc(profileRef, {
      ...profileData,
      uid: uid,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      isComplete: true,
    });

    return { status: true, message: "Profile created successfully" };
  } catch (error) {
    console.error("Error creating profile:", error);
    throw new Error("Failed to create profile.");
  }
};

export const getProfile = async (uid) => {
  try {
    const profileRef = doc(db, "user_profiles", uid);
    const profileSnap = await getDoc(profileRef);

    if (profileSnap.exists()) {
      return { status: true, data: profileSnap.data() };
    }
    return { status: false, message: "Profile not found" };
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to load profile.");
  }
};

export const updateProfile = async (uid, updatedData) => {
  try {
    const profileRef = doc(db, "user_profiles", uid);
    
    await updateDoc(profileRef, {
      ...updatedData,
      updatedAt: serverTimestamp(),
    });

    return { status: true, message: "Profile updated successfully" };
  } catch (error) {
    console.error("Error updating profile:", error);
    throw new Error("Failed to update profile.");
  }
};